<div class="table padding-vertical-25 padding-horizontal-10">
	<!--header-->
	<div class="row">
		<div class="col-2">
			<ngx-skeleton-loader [theme]="{ width: '70%', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
		</div>
		<div class="col-2">
			<ngx-skeleton-loader [theme]="{ width: '90%', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
		</div>
		<ng-container *ngFor="let col of GHOST_COLUMNS">
			<div class="col-2">
				<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
			</div>
		</ng-container>
	</div>
	<!--body-->
	<ng-container *ngFor="let rows of GHOST_ROWS">
		<div class="padding-top-25">
			<ngx-skeleton-loader [theme]="{ width: '100%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		</div>
		<div class="row">
			<div class="col-4">
				<ngx-skeleton-loader [theme]="{ width: '70%', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			</div>
			<ng-container *ngFor="let col of GHOST_COLUMNS">
				<div class="col-2">
					<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
				</div>
			</ng-container>
		</div>
		<div class="row">
			<div class="col-1">
				<ngx-skeleton-loader [theme]="{ width: '70%', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
				<ngx-skeleton-loader [theme]="{ width: '40%', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
				<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
				<ngx-skeleton-loader [theme]="{ width: '80%', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
			</div>
			<div class="col-3">
				<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
				<ngx-skeleton-loader [theme]="{ width: '70%', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
				<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
				<ngx-skeleton-loader [theme]="{ width: '60%', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
			</div>
			<ng-container *ngFor="let col of GHOST_COLUMNS">
				<div class="col-2">
					<ngx-skeleton-loader [theme]="{ width: '40%', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
					<ngx-skeleton-loader [theme]="{ width: '60%', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
					<ngx-skeleton-loader [theme]="{ width: '70%', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
					<ngx-skeleton-loader [theme]="{ width: '30%', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
				</div>
			</ng-container>
		</div>
	</ng-container>
</div>
